/**
 * Afterpay keyboard accessibility.
 *
 * <afterpay-placement> renders its content inside a shadow root (injected by Afterpay).
 * The interactive element is the inner `button.afterpay-logo`, not the host element, so:
 *  - the host must NOT be a tab stop (no tabindex on <afterpay-placement>)
 *  - the inner button must be keyboard focusable and have an accessible name
 */
(function () {
  'use strict';

  var BUTTON_SELECTOR = 'button.afterpay-logo, .afterpay-logo[role="button"]';
  var DEFAULT_LABEL = 'Afterpay - learn more about paying in installments';
  var observedRoots = new WeakSet();
  var scheduled = false;

  function fixButtons(root) {
    if (!root.querySelector('style[data-a11y-focus]')) {
      var style = document.createElement('style');
      style.setAttribute('data-a11y-focus', '');
      style.textContent = '.afterpay-logo:focus-visible{outline:2px solid #000 !important;outline-offset:2px !important;}';
      root.appendChild(style);
    }

    var buttons = root.querySelectorAll(BUTTON_SELECTOR);
    buttons.forEach(function (btn) {
      if (btn.getAttribute('tabindex') !== '0') {
        btn.setAttribute('tabindex', '0');
      }
      if (btn.tagName !== 'BUTTON' && btn.getAttribute('role') !== 'button') {
        btn.setAttribute('role', 'button');
      }
      if (!btn.hasAttribute('aria-label') && !btn.hasAttribute('aria-labelledby')) {
        btn.setAttribute('aria-label', DEFAULT_LABEL);
      }
      if (!btn.hasAttribute('aria-haspopup')) {
        btn.setAttribute('aria-haspopup', 'dialog');
      }
    });
  }

  function setupPlacement(host) {
    // Host is a non-interactive wrapper; remove the redundant tab stop.
    if (host.hasAttribute('tabindex')) {
      host.removeAttribute('tabindex');
    }

    var root = host.shadowRoot;
    if (!root) return false;

    fixButtons(root);

    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      new MutationObserver(function () {
        fixButtons(root);
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
    }
    return true;
  }

  function scan() {
    scheduled = false;
    var allReady = true;
    document.querySelectorAll('afterpay-placement').forEach(function (host) {
      if (!setupPlacement(host)) allReady = false;
    });
    return allReady;
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }

  function init() {
    scan();

    // Placements added later (cart drawer re-render, variant change, etc.)
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.localName === 'afterpay-placement' || node.querySelector('afterpay-placement'))) {
            scheduleScan();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Shadow root is attached by Afterpay after load; retry until every placement is ready.
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts++;
      if (scan() || attempts >= 40) window.clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
